(ns minorodata.components.forms.api-connection-test
  (:require [reagent.core :as reagent]
            [ajax.url]
            [reitit.frontend]
            [goog.string.format]
            [clojure.string]
            [minorodata.components.spinner.core :as c.spinner]
            [minorodata.app.handlers :as app.handlers]
            [ui.button]
            [ui.utils :refer [clsx]]
            [re-posh.core :as re-posh]))


(defn check-connection-render [{:keys [block source]}]
  (let [status                   (reagent/atom :idle)
        response                 (re-posh/subscribe [:source-connection/pull])

        check-connection-handler (fn [fields]
                                   (reset! status :in-progress)
                                   (let [fields-data (->> fields
                                                          (map (fn [[k {:keys [value]}]]
                                                                 [k value]))
                                                          (into {}))
                                         source-id   (:source/source-id source)
                                         source-data (assoc fields-data :source-id source-id)]
                                     (app.handlers/dispatch
                                      [:connections.api/test-connection {:source source-data
                                                                         :params block}])))]

    (reagent/create-class
     {:display-name "check-source-connection"

      :reagent-render
      (fn [{:keys [fields]}]
        [:div {:style {:width "100%"}}

         (when (= @status :idle)
           [:div {:class "my-4" :data-cy "source-test-block"}
            [ui.button/button {:full-width true
                               :variant    :primary-border
                               :on-click   #(check-connection-handler fields)
                               :data-cy    "api-connection-check"}
             "Check connection"]])

         (when (= @status :in-progress)
           (let [{:source-connection/keys [connection-status connection-message] :as result} @response
                 [check-message message-color] (if (= connection-status :ok)
                                                 ["Connected" "text-kleene-green"]
                                                 [(:error connection-message) "text-kleene-error-01"])]
             (if result
               [:div {:class "my-4" :data-cy "api-login-success"}
                [:span {:class (clsx message-color)}
                 check-message]
                [:div {:class "mt-2"}
                 [ui.button/button
                  {:full-width true
                   :variant    :secondary
                   :on-click   (fn []
                                 (re-posh/dispatch-sync [:source-connection/delete])
                                 (check-connection-handler fields))
                   :data-cy    "api-connection-retry"}
                  "Retry Connection"]]]

               [:div {:class "my-4"}
                [:span {:class "mr-2"}
                 [c.spinner/inline-configurable {:size 16}]]
                [:span {}
                 [:span "Checking Connection"]
                 [:br]]])))])})))


(defn check-conn [params]
  ^{:key (str (get-in params [:field :value])
              (get-in params [:errors]))}
  [check-connection-render params])


